import { render, staticRenderFns } from "./CreateProjectModal.vue?vue&type=template&id=3c788d5c&scoped=true&"
import script from "./CreateProjectModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateProjectModal.vue?vue&type=style&index=0&id=3c788d5c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c788d5c",
  null
  
)

export default component.exports